import React, { useState } from "react";
import StaticValueInput from "./StaticValueInput";

const DEFAULT_SCALE_DISPLAY_RANGE = { min: 1, max: 20 };
const DEFAULT_SCALE_NORM_RANGE = { min: 0.1, max: 1 };
const DEFAULT_POSITION_DISPLAY_RANGE = { min: 0, max: 100 };
const STATIC_IMAGE_SCALE_DISPLAY_RANGE = { min: 1, max: 30 };
const STATIC_IMAGE_SCALE_NORM_RANGE = { min: 0.1, max: 1.5 };
const STATIC_IMAGE_POSITION_DISPLAY_RANGE = { min: -20, max: 100 };

function ScalePositionPanel(props) {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <div
        className="EditorDrawerItemHeader"
        onClick={() => setOpen(!open)}
      >
        <span className="PanelOpenStatus">{open ? "▾" : "▸"}</span>
        <span>Position & Scale</span>
      </div>
      {open ? (
        <StyleDrawer
          {...props}
          positionX={props.positionX}
          positionY={props.positionY}
          scale={props.scale}
        />
      ) : null}
    </div>
  );
}

function StyleDrawer(props) {
  const isChildTextLabel = props.type === "STATIC_TEXT_LABEL" && props.parentImageId;
  const isStaticImageLabel = props.type === "STATIC_IMAGE" || props.type === "STATIC_IMAGE_LABEL";
  const scaleDisplayRange = isStaticImageLabel ? STATIC_IMAGE_SCALE_DISPLAY_RANGE : DEFAULT_SCALE_DISPLAY_RANGE;
  const scaleNormRange = isStaticImageLabel ? STATIC_IMAGE_SCALE_NORM_RANGE : DEFAULT_SCALE_NORM_RANGE;
  const positionDisplayRange = isStaticImageLabel ? STATIC_IMAGE_POSITION_DISPLAY_RANGE : DEFAULT_POSITION_DISPLAY_RANGE;

  const CenterPosition = () => {
    return (
      <div className="ScalePositionCenterContainer">
        <button
          className="ScalePositionCenterButton"
          onClick={() => {
            Inventum.labels.centerStaticLabel(props.id);
            props.getLabels();
          }}>
          <span className="material-icons">center_focus_strong</span>
          Center Position
        </button>
      </div>
    );
  };

  return (
    <div className="ScalePositionDrawerContainer">
      <div className="ScalePositionSection">
        <div className="ScalePositionSectionTitle">Scale</div>
        <div className="ScalePositionSectionContent">
          <StaticValueInput
            title="Scale"
            tooltip={`${scaleDisplayRange.min} - ${scaleDisplayRange.max}. Bigger may clip.`}
            min={scaleDisplayRange.min}
            max={scaleDisplayRange.max}
            value={Math.round(
              remapRange(
                props.scale,
                scaleNormRange.min,
                scaleNormRange.max,
                scaleDisplayRange.min,
                scaleDisplayRange.max
              )
            )}
            handleChange={(value) => {
              Inventum.labels.setStaticScale(
                props.id,
                remapRange(
                  value,
                  scaleDisplayRange.min,
                  scaleDisplayRange.max,
                  scaleNormRange.min,
                  scaleNormRange.max
                )
              );
              props.getLabels();
            }}
          />
        </div>
      </div>

      <div className="ScalePositionSection">
        <div className="ScalePositionSectionTitle">Position</div>
        <div className="ScalePositionSectionContent ScalePositionGrid">
          <StaticValueInput
            title="X"
            tooltip={`${positionDisplayRange.min} - ${positionDisplayRange.max}%. Bigger or smaller may clip.`}
            min={positionDisplayRange.min}
            max={positionDisplayRange.max}
            value={Math.round(props.positionX * 100)}
            handleChange={(value) => {
              Inventum.labels.setStaticPosition(props.id, { x: value / 100 });
              props.getLabels();
            }}
          />
          <StaticValueInput
            title="Y"
            tooltip={`${positionDisplayRange.min} - ${positionDisplayRange.max}%. Bigger or smaller may clip.`}
            min={positionDisplayRange.min}
            max={positionDisplayRange.max}
            value={Math.round(props.positionY * 100)}
            handleChange={(value) => {
              Inventum.labels.setStaticPosition(props.id, { y: value / 100 });
              props.getLabels();
            }}
          />
        </div>
      </div>

      {!isChildTextLabel && <CenterPosition />}
    </div>
  );
}

function remapRange(value, fmin, fmax, tmin, tmax) {
  return tmin + ((tmax - tmin) * (value - fmin)) / (fmax - fmin);
}

export { ScalePositionPanel };
